import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Fleet & Equipment', path: '/fleet' },
    { name: 'Safety', path: '/safety' },
    { name: 'Broker Setup', path: '/broker-setup' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-[#0B2A5B] sticky top-0 z-50 shadow-lg" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <img src="/logo.jpeg" alt="Douala Express Inc" className="h-12 w-auto rounded-sm" />
            <div>
              <span className="text-white font-bold text-xl tracking-tight font-['Montserrat']">
                DOUALA EXPRESS
              </span>
              <span className="block text-[#FFD700] text-xs tracking-widest uppercase">
                Inc.
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`px-4 py-2 text-sm font-medium transition-colors rounded-sm ${
                  isActive(link.path)
                    ? 'text-[#FFD700] bg-white/10'
                    : 'text-white/90 hover:text-[#FFD700] hover:bg-white/5'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:773-344-7748"
              className="flex items-center space-x-2 text-white/90 hover:text-[#FFD700] transition-colors"
              data-testid="phone-link"
            >
              <Phone className="h-4 w-4" />
              <span className="text-sm font-medium">773-344-7748</span>
            </a>
            <Link
              to="/contact"
              className="bg-[#C62828] text-white px-6 py-2.5 text-sm font-bold uppercase tracking-wide rounded-sm hover:bg-[#B71C1C] transition-all shadow-lg hover:shadow-red-900/30"
              data-testid="cta-quote-btn"
            >
              Get Quote
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-white p-2"
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="lg:hidden bg-[#0B2A5B] border-t border-white/10" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`block px-4 py-3 text-sm font-medium transition-colors rounded-sm ${
                  isActive(link.path)
                    ? 'text-[#FFD700] bg-white/10'
                    : 'text-white/90 hover:text-[#FFD700] hover:bg-white/5'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-white/10">
              <a
                href="tel:773-344-7748"
                className="flex items-center space-x-2 text-white/90 px-4 py-3"
              >
                <Phone className="h-4 w-4" />
                <span className="text-sm font-medium">773-344-7748</span>
              </a>
              <Link
                to="/contact"
                onClick={() => setIsOpen(false)}
                className="block mt-2 bg-[#C62828] text-white text-center px-6 py-3 text-sm font-bold uppercase tracking-wide rounded-sm"
              >
                Get Quote
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
